import { customizationsServiceInitializedSelector } from 'common/services/customizations-service/service-store/selectors';
import { useCustomizationStore } from 'common/services/customizations-service/service-store/service-store';
export var RequiredCustomization = function (_a) {
    var children = _a.children;
    var isCustomizationsInitialized = useCustomizationStore(customizationsServiceInitializedSelector);
    return isCustomizationsInitialized ? children : null;
};
